import { useState } from 'react';

const T = { bg: '#f0f5e8', cream: '#fffef0', greenDk: '#1b5e20', maroon: '#6d1b1b', orange: '#e65100', border: '#c8e6c9', header: 'linear-gradient(135deg, #090b72, #1a237e)' };

const panchangamData = [
  { title: '👑 ராஜா (Raja)', details: 'குரு – பருவகால மாற்றம், பண தட்டுப்பாடு ஏற்படும்.' },
  { title: '🏛️ மந்திரி (Mantri)', details: 'செவ்வாய் – நிலம், பூமி தொடர்பான வியாபாரம் செழிக்கும்.' },
  { title: '⚔️ சேனாதிபதி', details: 'சந்திரன் – வெளிநாடுகளில் உள்ள இந்தியர்கள் தாயகத்திற்கு திரும்புவர்.' },
  { title: '🌾 ஸஸ்யாதிபதி', details: 'சுக்கிரன் – ராணுவ நிலை உயரும், மஞ்சள் உற்பத்தி குறையும்.' },
  { title: '🌧️ தான்யாதிபதி', details: 'புதன் – புயல், மழை அதிகரிக்கும். ஆட்சியாளருக்கு சவால்கள்.' },
  { title: '💎 அர்காதிபதி', details: 'சந்திரன் – ஆடம்பர பொருட்களின் விலை உயரும்.' },
  { title: '☁️ மேகாதிபதி', details: 'சந்திரன் – நீர்நிலைகள் நிரம்பும், சில விபத்துகள் ஏற்படும்.' },
  { title: '🔥 ரஸாதிபதி', details: 'சூரியன் – லாபம் பெருகும், ஆன்மீகம் வளரும்.' },
  { title: '💰 நீரஸாதிபதி', details: 'சுக்கிரன் – விலைவாசி சற்றுக் குறையும்.' },
  { title: '🐄 பசுநாயகர்', details: 'பலபத்ர – இந்தியாவின் மதிப்பு உலகளவில் உச்சம் பெறும்.', hl: true },
];

const kandayaPalangal = [
  { star: 'அஸ்வினி', v1: '02', v2: '01', v3: '02' }, { star: 'பரணி', v1: '05', v2: '01', v3: '03' },
  { star: 'கிருத்திகை', v1: '00', v2: '02', v3: '00' }, { star: 'ரோகிணி', v1: '03', v2: '02', v3: '01' },
  { star: 'மிருகசீரிஷம்', v1: '06', v2: '01', v3: '04' }, { star: 'திருவாதிரை', v1: '01', v2: '02', v3: '03' },
  { star: 'புனர்பூசம்', v1: '05', v2: '00', v3: '01' }, { star: 'பூசம்', v1: '00', v2: '01', v3: '04' },
  { star: 'ஆயில்யம்', v1: '03', v2: '02', v3: '02' }, { star: 'மகம்', v1: '06', v2: '00', v3: '00' },
  { star: 'பூரம்', v1: '01', v2: '01', v3: '03' }, { star: 'உத்திரம்', v1: '04', v2: '02', v3: '01' },
  { star: 'அஸ்தம்', v1: '07', v2: '00', v3: '04' }, { star: 'சித்திரை', v1: '02', v2: '01', v3: '02' },
  { star: 'சுவாதி', v1: '05', v2: '02', v3: '00' }, { star: 'விசாகம்', v1: '00', v2: '00', v3: '03' },
  { star: 'அனுஷம்', v1: '03', v2: '01', v3: '01' }, { star: 'கேட்டை', v1: '06', v2: '02', v3: '04' },
  { star: 'மூலம்', v1: '01', v2: '00', v3: '02' }, { star: 'பூராடம்', v1: '04', v2: '01', v3: '00' },
  { star: 'உத்திராடம்', v1: '07', v2: '02', v3: '03' }, { star: 'திருவோணம்', v1: '02', v2: '00', v3: '01' },
  { star: 'அவிட்டம்', v1: '05', v2: '01', v3: '04' }, { star: 'சதயம்', v1: '00', v2: '02', v3: '02' },
  { star: 'பூரட்டாதி', v1: '03', v2: '00', v3: '00' }, { star: 'உத்திரட்டாதி', v1: '06', v2: '01', v3: '03' },
  { star: 'ரேவதி', v1: '01', v2: '02', v3: '01' },
];

const vaastuData = [
  { td: 'சித்தி-10', d: '23.04.2025-புதன் - 08.04 to 09.34' }, { td: 'வைகா-21', d: '04-06.2025-புதன்- 09.05 to 10.35' },
  { td: 'ஆடி-11', d: '27-07-2025- ஞாயிறு - 06.52 to 08.22' }, { td: 'ஆவ-06', d: '22-08-2025-வெள்ளி - 14.31 to 16.01' },
  { td: 'ஐப்ப-11', d: '28-10-2025- செவ்வா - 06.55 to 08.25' }, { td: 'கார்-08', d: '24-11-2025 - திங்கள் - 10.14 to 11.44' },
  { td: 'தை-12', d: '26-01-2026 - திங்கள் - 09.52 to 11.22' }, { td: 'மாசி-22', d: '06-03-2026 - வெள்ளி - 09.42 to 11.12' },
];

const grahaMovements = [
  { g: 'குரு', dt: '26.05.26 - 10.43', p: 'மிது to கடக' }, { g: 'ராகு', dt: '13.11.26 - 17.21', p: 'கும்ப to மகர' },
  { g: 'கேது', dt: '13.11.26 - 17.21', p: 'சிம்ம to கடக' }, { g: 'சனி', dt: 'ஆனி-18 வக்ர', p: 'கார்-1-வக்-நிவர்' },
  { g: 'சனி', dt: 'மாசி-22 (06.03.26) - 8.15 am', p: 'சனி பெயர்சி இல்லை' },
];

const asthamana = [
  { g: 'செவ்', a: '08.11.25 முதல் மேற்கே', u: 'சித்-04-17.04.26 கிழக்கே' },
  { g: 'குரு', a: 'ஆனி-26-10.07.26 மேற்கே', u: 'ஆடி-24 - 09.08.26 கிழக்கே' },
  { g: 'சுக்ர', a: 'ஐப்-09-26-10-26 மேற்கே', u: 'ஐப்-19 05.11.26 மேற்கே' },
  { g: 'சனி', a: 'பங்-11-25.03.27 மேற்கே', u: 'தொடர்ந்து அஸ்தமனத்தில்' },
];

const thS = { padding: '6px 8px', border: '1px solid #ccc', fontSize: '0.75rem' };
const thH = { ...thS, background: '#f1e312', color: '#d40b0b', fontWeight: 700 };

const CurrentYearPage = () => {
  const [section, setSection] = useState('all');

  const Section = ({ title, children }) => (
    <div style={{ marginBottom: '16px' }}>
      <h3 style={{ color: '#d40b0b', fontWeight: 700, borderBottom: '1px solid #ccc', paddingBottom: '4px', fontSize: '0.9rem', margin: '0 0 8px' }}>{title}</h3>
      {children}
    </div>
  );

  return (
    <div style={{ background: T.bg, minHeight: '80vh', padding: '10px' }}>
      <div style={{ background: T.header, padding: '12px', borderRadius: '10px', textAlign: 'center', marginBottom: '10px' }}>
        <h1 style={{ color: '#fff', margin: 0, fontSize: '1rem', fontWeight: 900 }}>🌟 இவ்வாண்டு சிறப்பு அம்சங்கள்</h1>
        <div style={{ color: '#c8e6c9', fontSize: '0.7rem' }}>பராபவ வருடம் (2025-2026)</div>
      </div>

      <Section title="நவநாயகர்கள்">
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tbody>
            {panchangamData.map((p, i) => (
              <tr key={i} style={{ background: p.hl ? '#ffffe0' : (i % 2 ? '#f5f8fc' : '#fff') }}>
                <td style={{ ...thS, fontWeight: 700, width: '40%', color: p.hl ? '#d40b0b' : 'blue' }}>{p.title}</td>
                <td style={{ ...thS, color: p.hl ? '#d40b0b' : '#333' }}>{p.details}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Section>

      <Section title="கந்தாய பலன்கள்">
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', whiteSpace: 'nowrap' }}>
            <thead><tr>{['நட்சத்திரம்', 'ஆதாயம்', 'விரயம்', 'அவமானம்'].map((h, i) => <th key={i} style={thH}>{h}</th>)}</tr></thead>
            <tbody>{kandayaPalangal.map((k, i) => (
              <tr key={i} style={{ background: i % 2 ? '#f5f8fc' : '#fff', color: 'blue' }}>
                <td style={thS}>{k.star}</td><td style={thS}>{k.v1}</td><td style={thS}>{k.v2}</td><td style={thS}>{k.v3}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      </Section>

      <Section title="வாஸ்து நாள் / நேரம்">
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', whiteSpace: 'nowrap' }}>
            <thead><tr><th style={thH}>தமிழ் தேதி</th><th style={thH}>ஆங்கில தேதி - நாள் - நேரம்</th></tr></thead>
            <tbody>{vaastuData.map((v, i) => (
              <tr key={i} style={{ background: i % 2 ? '#f5f8fc' : '#fff', color: 'blue' }}>
                <td style={{ ...thS, fontWeight: 700 }}>{v.td}</td><td style={thS}>{v.d}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      </Section>

      <Section title="க்ரஹப் பெயர்ச்சி">
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', whiteSpace: 'nowrap' }}>
            <thead><tr><th style={thH}>க்ரஹம்</th><th style={thH}>மாறும் தேதி</th><th style={thH}>இடம்</th></tr></thead>
            <tbody>{grahaMovements.map((g, i) => (
              <tr key={i} style={{ background: i % 2 ? '#f5f8fc' : '#fff', color: 'blue' }}>
                <td style={{ ...thS, fontWeight: 700 }}>{g.g}</td><td style={thS}>{g.dt}</td><td style={thS}>{g.p}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      </Section>

      <Section title="அஸ்தமன-தேதியும் நேரமும்">
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', whiteSpace: 'nowrap' }}>
            <thead><tr><th style={thH}>க்ரஹம்</th><th style={thH}>அஸ்தமன தேதி</th><th style={thH}>உதய தேதி</th></tr></thead>
            <tbody>{asthamana.map((a, i) => (
              <tr key={i} style={{ background: i % 2 ? '#f5f8fc' : '#fff', color: 'blue' }}>
                <td style={{ ...thS, fontWeight: 700 }}>{a.g}</td><td style={thS}>{a.a}</td><td style={thS}>{a.u}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      </Section>

      <Section title="க்ரஹணங்கள்">
        <div style={{ padding: '8px', fontWeight: 700, fontSize: '0.8rem', color: T.maroon }}>
          பராபவ வருடத்தில் ஒரே ஒரு சந்திர க்ரஹணம் மட்டுமே இந்தியாவில் தெரியும்.
        </div>
        <div style={{ background: T.cream, borderRadius: '8px', padding: '10px', border: `1px solid ${T.border}` }}>
          <div style={{ fontWeight: 700, color: '#d40b0b', marginBottom: '6px', fontSize: '0.85rem' }}>01 - சந்திர க்ரஹணம் - 20-02-2027</div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tbody>
              {[['க்ரஹணம்', 'சந்திர க்ரஹணம்'], ['தேதி', '20-02-2027'], ['ஆரம்பம்', '20-02-2027 -- 24.42 IST'], ['முடிவு', '21-02-2027 -- 06.43 IST'],
                ['புண்ய காலம்', 'புறநிழல் க்ரஹணம் - புண்யகாலம் இல்லை!'],
                ['பாதிப்பு', 'பரணி, பூரம், பூராடம், மகம் நக்ஷத்திரங்களுக்கு'],
              ].map(([k, v], i) => (
                <tr key={i} style={{ background: i % 2 ? '#f5f8fc' : '#fff' }}>
                  <td style={{ ...thS, fontWeight: 700, width: '35%' }}>{k}</td><td style={thS}>{v}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Section>
    </div>
  );
};

export default CurrentYearPage;